import Parse from "parse";
import { extractkeyValueFromArrayOfObject } from "../utils/json"

export const getBranchDataFromServer = (excelData) => {
    const branches = extractkeyValueFromArrayOfObject(excelData, "To Branch");
    return Parse.Cloud.run("getAllWarehouseInfo", {branches});
}